module.exports = __webpack_public_path__ + "static/media/cruise.a68bcc42.jpg";